<template>
  <v-container>
    <v-data-table
      data-cy="data-table"
      :loading="loading"
      :headers="headers"
      :items="devices"
      sort-by="name"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white" :extended="$vuetify.breakpoint.xs">
          <v-toolbar-title>{{ $t("Devices") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-if="!$vuetify.breakpoint.xs"
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            clearable
            single-line
            hide-details
            data-cy="input-search"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            data-cy="button-add-devices"
            :icon="$vuetify.breakpoint.mdAndDown"
            color="primary"
            dark
            class="mb-2"
            @click.stop="dialog = true"
          >
            <span v-if="$vuetify.breakpoint.lgAndUp">{{
              $t("New device")
            }}</span>
            <v-icon v-if="$vuetify.breakpoint.mdAndDown" x-large
              >mdi-plus-circle</v-icon
            >
          </v-btn>
          <v-btn
            depressed
            color="secondary"
            outlined
            :loading="loadingExport"
            class="ml-5"
            @click="exportDevices"
            >{{ $t("Export") }}
          </v-btn>
          <template v-if="$vuetify.breakpoint.xs" v-slot:extension>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('Search')"
              clearable
              single-line
              hide-details
            ></v-text-field>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item.applications="{ item }">
        <v-chip
          class="ma-1"
          v-for="(licence, index) in item.licences"
          :key="index"
          @click="infoLicence(licence)"
          :data-cy="`application-${licence.id}`"
          ><v-badge
            color="pink"
            dot
            :value="licence.is_expired || licence.trial"
            >{{ licence.application.name }}</v-badge
          ></v-chip
        >
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="mr-2" @click.stop="editItem(item)">mdi-pencil</v-icon>
        <v-icon @click.stop="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <add-edit-device-dialog
      v-model="dialog"
      @close="close"
    ></add-edit-device-dialog>
    <info-licence-dialog v-model="infoLicenceDialog"></info-licence-dialog>
  </v-container>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import { mapState } from "vuex";
import AddEditDeviceDialog from "@/components/AddEditDeviceDialog";
import InfoLicenceDialog from "@/components/InfoLicenceDialog";
// import { saveAs } from "file-saver";
import FileSaver from "file-saver";

export default {
  name: "DevicesIndex",
  components: { AddEditDeviceDialog, InfoLicenceDialog },
  mixins: [snackbar],
  data() {
    return {
      loading: false,
      loadingExport:false,
      dialog: false,
      search: "",
      infoLicenceDialog: false,
      exportFields: ['Modele','Numero de serie','Description','Agence','Client','Application']
    };
  },
  computed: {
    ...mapState({
      devices: (state) => state.devices.items,
      reseller: (state) => state.auth.user.id,
    }),
    headers() {
      return [
        {
          text: this.$t("Model"),
          align: "start",
          sortable: true,
          value: "model",
        },
        {
          text: this.$t("Serial number"),
          align: "start",
          sortable: true,
          value: "serial_number",
        },
        {
          text: this.$t("Description"),
          align: "start",
          sortable: true,
          value: "description",
        },
        {
          text: this.$t("Entity"),
          align: "start",
          sortable: true,
          value: "reseller_entity.name",
        },
        {
          text: this.$t("Customer"),
          align: "start",
          sortable: true,
          value: "client.name",
        },
        {
          text: this.$t("Applications"),
          align: "start",
          sortable: false,
          value: "applications",
        },
        {
          text: this.$t("Actions"),
          align: "center",
          value: "actions",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("devices/fetchAll")
      .then(() => (this.loading = false))
      .catch(() => (this.loading = false));
  },
  methods: {
    back() {
      this.$router.push({
        name: "Resellers Show",
        params: { id: this.$router.currentRoute.params.id },
      });
    },
    editItem(item) {
      this.$store.commit("devices/setEditedId", item.id);
      this.$store.commit("devices/setEditedItem", Object.assign({}, item));
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("Are you sure you want to delete this item ?"))) {
        this.$store
          .dispatch("devices/deleteItem", item.id)
          .then(() =>
            this.snackbar("success", this.$t("snackbar-message-device.deleted"))
          )
          .catch(() =>
            this.snackbar("error", this.$t("snackbar-message-device.error"))
          );
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$store.dispatch("devices/resetEditedItem");
      }, 300);
    },
    infoLicence(item) {
      this.$store.commit("licences/setSelectedItem", item);
      this.infoLicenceDialog = true;
    },
    exportDevices(){
      this.loadingExport = true;
      try {
        var sep='sep=,'
        var csvStr = sep+ "\n" +this.exportFields.join(",") + "\n";
        this.devices.forEach((device) => {
          var model = device.model == null ? '' : device.model
          var serial_number = device.serial_number
          var description = device.description == null ? '' : device.description
          var agence = device.reseller_entity.name
          var client = device.client == null ? '' : device.client.name
          var licenceApplis = ""
          if(device.licences.length != 0){
            device.licences.forEach((licence) => {
              licenceApplis += licence.application.name + " "
            })
          }
          var application = licenceApplis
          csvStr += `"${model}"` + "," + `"${serial_number}"` + "," + `"${description}"` + "," + `"${agence}"` + "," + `"${client}"` + "," + `"${application}"` + "\n";
        });
        var blob = new Blob(['\uFEFF'+csvStr], {type: "text/csv;charset=utf-8;"});
        FileSaver.saveAs(blob, "exportDevices.csv");
        this.loadingExport = false;
      } catch (error) {
        this.loadingExport = false;
      }      
    }
  },
};
</script>